import React, { useContext, useEffect, useState, forwardRef } from 'react';
import {
  Avatar,
  Modal,
  Select,
  MultiSelect,
  Switch,
  TextInput,
  Textarea,
  Chip,
  Chips,
  // Popover,
  Group,
  Text,
} from '@mantine/core';
import { ReactComponent as CrossIcon } from 'assets/icons/crossIcon2.svg';
// import CalendarImage from 'assets/images/calendar.svg';
import { ReactComponent as CalendarIcon } from 'assets/icons/calanderIcon.svg';
import { ReactComponent as ClockIcon } from 'assets/icons/clockIcon.svg';

import PrimaryButton from 'components/primaryButton';
import { Controller, useForm } from 'react-hook-form';
import { DatePicker } from '@mantine/dates';
import dateFormatter from 'helper/dateFormatter';
import useCalendarEvents from 'pages/adminCalender/pages/organisation-calendar/hooks/useCalendarEvents';
import useAddCalendarEvent from 'pages/adminCalender/pages/organisation-calendar/hooks/useAddCalendarEvent';
import useEditCalendarEvent from 'pages/adminCalender/pages/organisation-calendar/hooks/useEditCalendarEvent';
import { ReactComponent as DropIcon } from '../../../../assets/icons/downArrow.svg';
import { AuthContext } from 'context/authContext';
// import { ReactComponent as ClockIcon } from "../../../../assets/icons/clockIcon.svg";
// import InputAttendee from "./inputAttendee";

import dayjs from 'dayjs';
import useGetAllTeamMembers from 'pages/team/pages/myTeam/hooks/useGetAllTeamMembers';

export default function MeetingsEventModal({
  openModal,
  setOpenModal,
  modalTitle,
  selectedEvent,
  setOpenEventModal,
  openEventModal,
  clickedDate,
  date,
  view,
}) {
  function sortDays(days) {
    let daysSort = [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Satuday',
      'Sunday',
    ];
    let sortedDays = [];
    daysSort.forEach((value) => {
      if (days.includes(value)) {
        sortedDays.push(value);
      }
    });
    return sortedDays;
  }
  let day = new Date().toLocaleString('en-us', { weekday: 'long' });
  const [data, setData] = useState([]);
  const [opened, setOpened] = useState(false);
  const [showRecurringInput, setShowRecurringInput] = useState(false);
  const [showOptionalAttendees, setShowOptionalAttendees] = useState(false);

  const [checked, setChecked] = useState(false);
  const { authState } = useContext(AuthContext);
  const getTeamMembersData = useGetAllTeamMembers(null, 'True');
  const [isInvalid, setIsInvalid] = useState(false);
  const [selectedDays, setSelectedDays] = useState([day]);
  // calculating difference between start and end time in meeting
  const diffTime = (fromtime, totime) => {
    const ft = dayjs(`2000-01-01 ${fromtime}`);
    const tt = dayjs(`2000-01-01 ${totime}`);
    const mins = tt.diff(ft, 'minutes', true);
    var totalHours = parseInt(mins / 60);
    var totalMins = dayjs().minute(mins).$m;

    return totalHours
      ? totalHours + 'hrs . ' + totalMins + ' mins'
      : totalMins + ' mins';
  };

  // const reqData =
  //   getTeamMembersData?.data?.pages[0]?.data?.map((emp) => {
  //     return {
  //       image: emp?.profile_picture,
  //       value: emp?.id,
  //       label: emp?.user__first_name,
  //       designation: emp?.designation__name,
  //     };
  //   }) || [];
  // console.log('regData', getTeamMembersData?.data?.pages[0]?.data);

  const getDropdownData = () => {
    const dataArray = [];

    getTeamMembersData?.data?.pages[0]?.data?.forEach((employee) => {
      dataArray.push({
        image: employee?.profile_picture,
        label: employee.user__first_name,
        value: `${employee?.user__email}`,
        description: employee?.designation__name,
        disabled: employee?.user__is_active ? false : true,
      });
    });
    return dataArray?.concat(data);
  };

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,

    reset,
    setValue,
  } = useForm({ mode: 'onChange' });

  const closeModal = () => {
    setOpenModal(false);
    reset({});
    setOpened(false);
    setChecked(false);
  };
  useEffect(() => {
    if (watch('from_time') < watch('to_time')) {
      setIsInvalid(true);
    } else {
      setIsInvalid(false);
    }
    // eslint-disable-next-line
  }, [watch('to_time')]);
  useEffect(() => {
    setValue('recurring_frequency', 'everyday');
  }, [setValue]);
  useEffect(() => {
    if (checked === false) {
      setOpened(false);
    }
  }, [checked]);
  useEffect(() => {
    setValue('recurring_for_date', watch('for_date'));

    // eslint-disable-next-line
  }, [watch('for_date')]);

  const handleMeetingCheck = () => {
    if (checked === true) {
      setShowRecurringInput(!showRecurringInput);
      setOpened(!opened);
    } else if (checked === false) {
      setShowRecurringInput(false);
      setOpened(true);
    }
  };

  // const handleDropCheck = () => {
  //   if (checked === false) {
  //     setOpened(!opened);
  //   } else if (checked === true) {
  //     setShowRecurringInput(true);
  //   }
  // };

  useEffect(() => {
    setValue('for_date', date);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);
  useEffect(() => {
    if (
      selectedDays.length === 0 &&
      watch('recurring_frequency') === 'weekly'
    ) {
      setSelectedDays([day]);
    }
    // eslint-disable-next-line
  }, [watch('recurring_frequency'), selectedDays]);

  // creating body for the mail
  /* function createMailBody(data) {
    return `<p><strong>Time: </strong>${dayjs(data?.for_date).format(
      'dddd,MMMM D,YYYY'
    )} 
    ${dayjs(`2000-01-01 ${data?.from_time}`).format('h:m A')} - ${dayjs(
      `2000-01-01 ${data?.to_time}`
    ).format('h:m A')} (${diffTime(data?.from_time, data?.to_time)}) </p>
    <p><strong>Location: </strong>${showOnline ? 'Online' : data?.location}</p>
    <p><strong>Meeting Description</strong>:&nbsp;${data?.description}</p>`;
  } */

  const submitHandler = (data) => {
    // data = { ...data, mailBody: createMailBody(data) };
    const for_date = dateFormatter(data?.for_date, 'YYYY-MM-DD');
    const to_date = dateFormatter(data?.to_date, 'YYYY-MM-DD');
    const recurring_for_date = dateFormatter(
      data?.recurring_for_date,
      'YYYY-MM-DD'
    );
    const recurring_to_date = dateFormatter(
      data?.recurring_to_date,
      'YYYY-MM-DD'
    );
    if (modalTitle === 'Schedule a meet') {
      if (!opened) {
        delete data['recurring_for_date'];
        delete data['recurring_to_date'];
        delete data['selectedDays'];
        delete data['recurring_frequency'];

        addCalendarEventMutation.mutate({
          ...data,
          for_date,
          to_date,
          created_by_id: authState?.user_id,
          type: 'meeting',
          location: showOnline ? 'Online' : data?.location,
        });
      } else {
        addCalendarEventMutation.mutate({
          ...data,
          for_date,
          to_date,
          recurring_for_date,
          recurring_to_date,
          created_by_id: authState?.user_id,
          selectedDays,
          location: showOnline ? 'Online' : data?.location,
          type: 'meeting',
        });
      }
    }

    if (modalTitle === 'Edit Meeting') {
      const for_date = dateFormatter(data?.for_date, 'YYYY-MM-DD');
      const to_date = dateFormatter(data?.to_date, 'YYYY-MM-DD');
      if (!opened) {
        delete data['recurring_for_date'];
        delete data['recurring_to_date'];
        delete data['selectedDays'];
        delete data['recurring_frequency'];

        editCalendarEventMutation.mutate({
          ...data,
          for_date,
          to_date,
          created_by_id: authState?.user_id,
          type: 'meeting',
          location: showOnline ? 'Online' : data?.location,
          id: selectedEvent,
        });
      } else {
        editCalendarEventMutation.mutate({
          ...data,
          for_date,
          to_date,
          recurring_for_date,
          recurring_to_date,
          created_by_id: authState?.user_id,
          selectedDays,
          location: showOnline ? 'Online' : data?.location,
          type: 'meeting',
          id: selectedEvent,
        });
      }
    }
  };

  const formErrorMessage = (name) => {
    return (
      errors?.[name] && (
        <p className='text-sm font-semibold text-red-500'>
          {errors?.[name]?.message}
        </p>
      )
    );
  };

  const SelectItem = forwardRef(
    ({ image, label, designation, ...others }, ref) => (
      <div ref={ref} {...others}>
        <Group noWrap>
          <Avatar
            src={image}
            size={50}
            color='red'
            radius={50}
            className='capitalize'
          >
            {label[0]}
          </Avatar>
          <div>
            <Text size='sm'>{label}</Text>
            <Text size='xs' color='dimmed'>
              {designation}
            </Text>
          </div>
        </Group>
      </div>
    )
  );

  // CALENDAR
  const getSpecificEvent = useCalendarEvents(selectedEvent);
  const addCalendarEventMutation = useAddCalendarEvent(closeModal);
  const editCalendarEventMutation = useEditCalendarEvent(closeModal);
  // console.log('data:', getSpecificEvent?.data?.data[0]);
  const [showOnline, setShowOnline] = useState(false);
  useEffect(() => {
    if (selectedEvent) {
      const data = getSpecificEvent?.data?.data[0];
      if (data?.location === 'Online') {
        setShowOnline(true);
      }
      setChecked(data?.is_recurring);
      setOpened(data?.is_recurring);
      setShowOptionalAttendees(!!data?.optional_attendees?.[0]);
      reset({
        name: data?.name,
        required_attendes: data?.required_attendes,
        optional_attendees: data?.optional_attendees,
        for_date: new Date(data?.for_date),
        to_date: new Date(data?.to_date),
        is_holiday: data?.is_holiday,
        location: data?.location === 'Online' ? '' : data?.location,
        holiday_type_id: `${data?.holiday_type_id}`,
        from_time: data?.from_time,
        to_time: data?.to_time,
        all_day_event: data?.all_day_event,
        mandatory: data?.mandatory,
        description: data?.description,
        recurring_for_date: data?.recurring_for_date,
        recurring_to_date: data?.recurring_to_date,
        recurring_frequency: data?.recurring_frequency,
        selectedDays: data?.selectedDays,

        // data?.from_time + data?.to_time
      });
    }
    // eslint-disable-next-line
  }, [getSpecificEvent?.data?.data, openModal]);

  // useEffect(() => {
  //   if (watch('is_holiday')) {
  //     setValue('all_day_event', false);
  //     setValue('mandatory', false);
  //   }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [watch('is_holiday')]);

  useEffect(() => {
    if (!selectedEvent && watch('for_date')) {
      setValue('to_date', watch('for_date'));
    }
    // eslint-disable-next-line
  }, [watch('for_date'), watch, setValue]);

  return (
    <Modal
      opened={openModal}
      onClose={closeModal}
      title={modalTitle}
      withCloseButton={false}
      overlayColor={'#F8F7F799'}
      overlayBlur={20}
      overlayOpacity={0.5}
      overflow='inside'
      centered
      size={'xl'}
      radius='md'
      transitionDuration={100}
      classNames={{
        title: 'mx-auto text-000000 font-semibold text-18',
        modal: 'pl-10',
        body: 'scroller -mr-4 pr-10',
        header: 'mb-4',
        root: '3xl:scale-125',
      }}
    >
      <div>
        <form className='mt-6 relative' onSubmit={handleSubmit(submitHandler)}>
          {
            // <div className='flex justify-between'>
            //   <div className='flex justify-center w-44'>
            //     <Select
            //       // onChange={(e) => handleDropDown(e)}
            //       className='flex justify-center items-baseline'
            //       classNames={{
            //         label: 'text-primary',
            //         input: 'text-neutralsGrey pl-2',
            //         rightSection: '-mr-1',
            //       }}
            //       defaultValue='General'
            //       rightSection={<DropIcon size={14} />}
            //       label='Category : '
            //       styles={{
            //         rightSection: {
            //           pointerEvents: 'none',
            //           justifyContent: 'end',
            //         },
            //         input: {
            //           border: 'none',
            //           fontSize: '16px',
            //           paddingRight: '0',
            //           paddingLeft: '0',
            //           width: '6.5rem',
            //         },
            //         // label: {
            //         //   width: '8.3rem',
            //         // },
            //       }}
            //       data={[
            //         { value: 'General', label: 'General' },
            //         { value: 'Mandatory', label: 'Mandatory' },
            //         { value: 'Optional', label: 'Optional' },
            //         { value: 'All team', label: 'All team' },
            //         { value: 'Others', label: 'Others' },
            //       ]}
            //     />
            //   </div>
            //   <div className='flex justify-center w-44'>
            //     <Select // onChange={(e) => handleDropDown(e)}
            //       className='flex justify-center items-baseline'
            //       classNames={{
            //         label: 'text-primary',
            //         input: 'text-neutralsGrey pl-2',
            //         rightSection: '-mr-1',
            //       }}
            //       defaultValue='All team'
            //       rightSection={<DropIcon size={14} />}
            //       label='Time zone : '
            //       styles={{
            //         rightSection: {
            //           pointerEvents: 'none',
            //           justifyContent: 'end',
            //         },
            //         input: {
            //           border: 'none',
            //           fontSize: '16px',
            //           paddingRight: '0',
            //           paddingLeft: '0',
            //           width: '6.5rem',
            //         },
            //         // label: {
            //         //   width: '8.3rem',
            //         // },
            //       }}
            //       data={[
            //         { value: 'All team', label: 'All team' },
            //         { value: 'Mandatory', label: 'Mandatory' },
            //       ]}
            //     />
            //   </div>
            //   <div className='flex justify-center w-46'>
            //     <Select // onChange={(e) => handleDropDown(e)}
            //       className='flex justify-center items-baseline'
            //       classNames={{
            //         label: 'text-primary',
            //         input: 'text-neutralsGrey pl-2',
            //         rightSection: 'mr-2',
            //       }}
            //       defaultValue='Yes'
            //       rightSection={<DropIcon size={14} />}
            //       label='Mandatory : '
            //       styles={{
            //         rightSection: {
            //           pointerEvents: 'none',
            //           justifyContent: 'start',
            //         },
            //         input: {
            //           border: 'none',
            //           fontSize: '16px',
            //           paddingRight: '0',
            //           paddingLeft: '0',
            //           width: '6.5rem',
            //         },
            //         // label: {
            //         //   width: '8.3rem',
            //         // },
            //       }}
            //       data={[
            //         { value: 'Yes', label: 'Yes' },
            //         { value: 'No', label: 'No' },
            //       ]}
            //     />
            //   </div>
            // </div>
          }
          <div className='mt-2 mb-4'>
            <Controller
              control={control}
              name='name'
              defaultValue={''}
              rules={{ required: 'Required' }}
              render={({ field }) => (
                <TextInput
                  {...field}
                  label='Title'
                  size='md'
                  classNames={{
                    input: 'border-primary',
                    label: 'text-neutralsGrey',
                  }}
                />
              )}
            />
            {formErrorMessage('name')}
          </div>
          <div className='mb-4'>
            <div className='mb-4'>
              <Controller
                control={control}
                name='required_attendes'
                defaultValue={''}
                rules={{ required: 'Required' }}
                render={({ field }) => (
                  <MultiSelect
                    {...field}
                    label='Required attendees'
                    className='justify-center items-baseline'
                    rightSection={<DropIcon size={14} />}
                    placeholder='Search or select'
                    itemComponent={SelectItem}
                    data={
                      getTeamMembersData?.data?.pages[0]?.data?.length
                        ? getDropdownData()
                        : []
                    }
                    searchable
                    creatable
                    onCreate={(query) => {
                      const item = { value: query, label: query };
                      setData((current) => [...current, item]);
                      return item;
                    }}
                    getCreateLabel={(query) => `Use this address: ${query}`}
                    maxDropdownHeight={400}
                    nothingFound='Nobody here'
                    classNames={{
                      label: 'text-neutralsGrey',
                      input: 'border-primary',
                      values: 'mt-1 p-0',
                    }}
                    styles={{
                      rightSection: { pointerEvents: 'none' },
                      input: {
                        fontSize: '16px',
                        height: '42px',
                      },
                    }}
                  />
                )}
              />
              {formErrorMessage('required_attendes')}
              {showOptionalAttendees ? (
                ''
              ) : (
                <button
                  onClick={() =>
                    setShowOptionalAttendees(!showOptionalAttendees)
                  }
                  className='text-67A1EF border-none float-right'
                >
                  Add optional attendees
                </button>
              )}
            </div>
            {showOptionalAttendees ? (
              <div className='mt-4 mb-4'>
                <Controller
                  control={control}
                  name='optional_attendees'
                  defaultValue={''}
                  rules={{ required: 'Required' }}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      className='justify-center items-baseline'
                      rightSection={<DropIcon size={14} />}
                      label='Optional attendees'
                      placeholder='Search optional attendees to add'
                      itemComponent={SelectItem}
                      required
                      creatable
                      data={
                        getTeamMembersData?.data?.pages[0]?.data?.length
                          ? getDropdownData()?.filter(
                              (emp) =>
                                watch('required_attendes').indexOf(
                                  emp.value
                                ) === -1
                            )
                          : []
                      }
                      onCreate={(query) => {
                        const item = { value: query, label: query };
                        setData((current) => [...current, item]);
                        return item;
                      }}
                      getCreateLabel={(query) => `Use this address: ${query}`}
                      searchable
                      maxDropdownHeight={400}
                      nothingFound='Nobody here'
                      classNames={{
                        label: 'text-neutralsGrey',
                        input: 'border-primary',
                        values: 'mt-1 p-0',
                      }}
                      styles={{
                        rightSection: { pointerEvents: 'none' },
                        input: {
                          fontSize: '16px',
                          height: '42px',
                        },
                      }}
                    />
                  )}
                />
                {formErrorMessage('optional_attendees')}
              </div>
            ) : (
              ''
            )}

            {/*Selected attendees to be shown here
             <div className='flex'>
              <Avatar src='avatar.png' alt="it's me" />
              <Avatar src='avatar.png' alt="it's me" />
              <Avatar src='avatar.png' alt="it's me" />
            </div> */}
          </div>
          <div className='flex justify-around gap-4 mb-4 w-full'>
            <div className='w-1/3'>
              <Controller
                control={control}
                name='for_date'
                rules={{
                  required: 'Required',
                }}
                defaultValue={dayjs(date)}
                render={({ field }) => (
                  <DatePicker
                    {...field}
                    label='Schedule on'
                    size='md'
                    rightSection={<CalendarIcon />}
                    classNames={{
                      input: 'border-primary h-11 ',
                      label: 'text-neutralsGrey',
                      rightSection: 'pointer-events-none',
                    }}
                  />
                )}
              />
              {formErrorMessage('for_date')}
            </div>
            <div className='flex flex-col  gap-1 w-1/3'>
              <label className='text-neutralsGrey '>From</label>
              <div className='relative flex items-center'>
                <Controller
                  control={control}
                  label='From'
                  name='from_time'
                  defaultValue={''}
                  rules={{ required: 'Required' }}
                  render={({ field }) => (
                    <input
                      {...field}
                      type='time'
                      className='pr-8 px-2  border-primary border rounded h-11 w-full'
                    />
                  )}
                />
                <ClockIcon className='absolute right-3 ' />
              </div>
              {formErrorMessage('from_time')}
            </div>
            {/* <p>{total_time}</p> */}
            <div className='flex flex-col  gap-1 w-1/3'>
              <label className='text-neutralsGrey'>Till</label>
              <div className='relative flex items-center'>
                <Controller
                  control={control}
                  name='to_time'
                  defaultValue={''}
                  rules={{
                    required: 'Required',
                    validate: () =>
                      watch('from_time') < watch('to_time') ||
                      'Invalid time selected',
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      type='time'
                      className='pr-8 px-2 border-primary border rounded h-11   w-full'
                    />
                  )}
                />
                <ClockIcon className='absolute right-3 ' />
              </div>

              {formErrorMessage('to_time')}
            </div>

            {
              //calculating time difference
              watch('from_time') && watch('to_time') && isInvalid && (
                <div className='w-1/4'>
                  <p className='mt-10 text-center text-xs '>
                    {diffTime(watch('from_time'), watch('to_time'))}
                  </p>
                </div>
              )
            }
          </div>
          <div className='flex gap-x-3 items-center mb-4'>
            <span className='label-filter-off text-14'>Recurring meeting</span>
            <div onClick={() => setOpened((o) => !o)}>
              <Switch
                color='primary'
                checked={checked}
                onChange={(event) => {
                  setChecked(event.currentTarget.checked);
                  handleMeetingCheck();
                }}
              />
            </div>
          </div>
          {
            // <Popover
            //   opened={opened}
            //   onChange={setOpened}
            //   closeOnClickOutside
            //   position='bottom'
            //   placement='start'
            //   width={150}
            //   radius={'md'}
            //   // gutter={-30}
            //   styles={{
            //     popover: { transform: 'translate(115px, -35px)' },
            //   }}
            // >
            //   <div className='space-y-4  px-3 select-none'>
            //     <div
            //       onClick={() => {
            //         handleDropCheck();
            //         setOpened(!opened);
            //       }}
            //       className='cursor-pointer space-y-2 '
            //     >
            //       <p>Weekly</p>
            //       <p>Monthly</p>
            //       <p>Annually</p>
            //       <p>Custom</p>
            //     </div>
            //   </div>
            // </Popover>
          }
          {opened ? (
            <div className='grid grid-cols-3 gap-x-3 mb-4 pr-4'>
              <div>
                <Controller
                  control={control}
                  name='recurring_for_date'
                  rules={{
                    required: 'Required',
                  }}
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      label='From'
                      size='md'
                      rightSection={<CalendarIcon />}
                      classNames={{
                        input: 'border-primary',
                        label: 'text-neutralsGrey',
                        rightSection: 'pointer-events-none',
                      }}
                    />
                  )}
                />
                {formErrorMessage('recurring_for_date')}
              </div>
              <div>
                <Controller
                  control={control}
                  name='recurring_to_date'
                  rules={{
                    required: 'Required',
                    validate: () =>
                      watch('recurring_for_date') <=
                        watch('recurring_to_date') || 'invalid date',
                  }}
                  defaultValue={new Date()}
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      label='Till'
                      size='md'
                      rightSection={<CalendarIcon />}
                      classNames={{
                        input: 'border-primary',
                        //hidden the visibilty of label as per the figma design
                        label: 'text-neutralsGrey',
                        rightSection: 'pointer-events-none',
                      }}
                    />
                  )}
                />
                {formErrorMessage('recurring_to_date')}
              </div>
              <div className='cursor-pointer w-[260px] '>
                <Controller
                  control={control}
                  name='recurring_frequency'
                  rules={{ required: 'Required' }}
                  defaultValue='everyday'
                  render={({ field }) => (
                    <Select
                      {...field}
                      // onChange={(e) => handleDropDown(e)}
                      label='Repetition'
                      searchable
                      rightSection={<DropIcon size={14} />}
                      styles={{
                        rightSection: { pointerEvents: 'none' },
                        input: {
                          fontSize: '16px',
                          paddingRight: '0',
                          height: '42px',
                        },
                        //hidden the visibilty of label as per the figma design
                      }}
                      classNames={{
                        input: 'border-primary',
                        label: 'text-neutralsGrey',
                        rightSection: 'pointer-events-none',
                      }}
                      data={[
                        { value: 'everyday', label: 'Everyday' },
                        { value: 'weekly', label: 'Weekly' },
                        { value: 'monthly', label: 'Monthly' },
                        { value: 'annually', label: 'Annually' },
                      ]}
                    />
                  )}
                />
                {watch('recurring_frequency') === 'weekly' && (
                  <div className='mt-4'>
                    <Chips
                      multiple={true}
                      value={selectedDays}
                      onChange={setSelectedDays}
                      classNames={{
                        label:
                          'p-0 w-7 text-center rounded-full font-medium text-primary',
                        iconWrapper: 'hidden',
                        checkIcon: 'hidden',
                        checked: 'text-[#ffffff] bg-primary hover:bg-primary',
                      }}
                    >
                      <Chip value='Monday'>M</Chip>
                      <Chip value='Tuesday'>T</Chip>
                      <Chip value='Wednesday'>W</Chip>
                      <Chip value='Thursday'>TH</Chip>
                      <Chip value='Friday'>F</Chip>
                      <Chip value='Saturday'>SA</Chip>
                      <Chip value='Sunday'>S</Chip>
                    </Chips>
                  </div>
                )}
                <div className='mt-2'>
                  {watch('recurring_frequency') === 'everyday' && (
                    <p className='text-neutralsGrey text-sm'>
                      {`Occurs every day starting `}
                      {dayjs(watch('recurring_for_date')).format('DD-MM-YYYY')}
                    </p>
                  )}
                  {watch('recurring_frequency') === 'weekly' &&
                  selectedDays.length === 7 ? (
                    <p className='text-neutralsGrey text-sm'>
                      {`Occurs every day starting `}
                      {dayjs(watch('recurring_for_date')).format('DD-MM-YYYY')}
                    </p>
                  ) : (
                    watch('recurring_frequency') === 'weekly' && (
                      <p className='text-neutralsGrey text-xs'>
                        {`Occurs every `} {sortDays(selectedDays).toString()}{' '}
                        {`starting `}
                        {dayjs(watch('recurring_for_date')).format(
                          'DD-MM-YYYY'
                        )}
                      </p>
                    )
                  )}
                  {watch('recurring_frequency') === 'monthly' && (
                    <p className='text-neutralsGrey text-xs flex gap-x-1'>
                      {`Occurs every month on day `}{' '}
                      {dayjs(watch('recurring_for_date')).format('D')}{' '}
                      {`starting `}
                      <p className='text-[10px]'>
                        {dayjs(watch('recurring_for_date')).format(
                          'DD-MM-YYYY'
                        )}
                      </p>
                    </p>
                  )}
                  {watch('recurring_frequency') === 'annually' && (
                    <p className='text-neutralsGrey text-xs flex gap-x-1'>
                      {`Occurs every year on day `}{' '}
                      {dayjs(watch('recurring_for_date')).format('D')} {`of `}
                      <p className='text-[10px]'>
                        {dayjs(watch('recurring_for_date')).format('MMMM')}
                      </p>
                    </p>
                  )}
                </div>
                {formErrorMessage('recurring_frequency')}
              </div>
            </div>
          ) : (
            ''
          )}
          <div className='mb-4'>
            <div className='flex gap-x-3 float-right'>
              <span>Online</span>
              <Switch
                checked={showOnline}
                onChange={() => setShowOnline(!showOnline)}
              />
            </div>
            <Controller
              control={control}
              name='location'
              defaultValue={''}
              rules={showOnline ? { required: null } : { required: 'Required' }}
              render={({ field }) => (
                <TextInput
                  {...field}
                  label='Location'
                  disabled={showOnline ? true : false}
                  placeholder='Add a location'
                  size='md'
                  classNames={{
                    input: 'border-primary',
                    label: 'text-neutralsGrey',
                  }}
                />
              )}
            />
            {formErrorMessage('location')}
          </div>
          <div>
            <Controller
              control={control}
              name='description'
              defaultValue={''}
              rules={{ required: 'Required' }}
              render={({ field }) => (
                <Textarea
                  {...field}
                  label='Write a description'
                  size='md'
                  classNames={{
                    input: 'border-primary',
                    label: 'text-neutralsGrey',
                  }}
                />
              )}
            />
            {formErrorMessage('description')}
          </div>
          <div className='flex justify-center mt-6'>
            <button>
              <PrimaryButton>
                <p>Schedule a meeting</p>
              </PrimaryButton>
            </button>
          </div>
        </form>
        <CrossIcon
          className='absolute top-5 h-4 w-5 cursor-pointer left-[90%]'
          onClick={closeModal}
        />
      </div>
    </Modal>
  );
}
